import React, { useEffect } from "react";

const Sitemap: React.FC = () => {
  useEffect(() => {
    // Redirect to backend sitemap.xml endpoint
    const backendUrl =
      process.env.REACT_APP_SERVER_URL || "http://localhost:3002";
    const sitemapUrl = `${backendUrl}/sitemap.xml`;

    // Redirect to the backend sitemap
    window.location.href = sitemapUrl;
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        flexDirection: "column",
        color: "white",
        backgroundColor: "#1a1a1a",
      }}
    >
      <h2>Redirecting to Sitemap...</h2>
      <p>You will be redirected to the sitemap.xml file.</p>
    </div>
  );
};

export default Sitemap;
